import request from '../../utils/request'

export function exportImportTemplate (params) {
  return request.post('/business/goodsImportTask/exportTemplate', params, {
    trim: true,
    download: true
  })
}

export function importExcelAsync (formData) {
  return request.post('/business/goodsImportTask/importExcelAsync', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function fetchTaskPage (data) {
  return request.post('/business/goodsImportTask/page', data, { trim: true })
}

export function fetchList (data) {
  return fetchTaskPage(data)
}

export function fetchTaskById (id) {
  return request.get(`/business/goodsImportTask/${id}`)
}

export function hasUnfinishedTask () {
  return request.get('/business/goodsImportTask/hasUnfinished')
}
